import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import logo from '../assets/LOGO2.png';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import QrCodeIcon from '@mui/icons-material/QrCode';
import LearnerQRModal from './learneQR/LearnerQRModal';
import { getLearnerQRCode } from '../services/AttendanceServices';
import { toast } from 'react-toastify';

export default function Header({ handleDrawer }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [user, setUser] = React.useState({})
  const [open, setOpen] = React.useState(false);
  const [qrImage, setQrImage] = React.useState(null);
  const [qrLoading, setQrLoading] = React.useState(false);

  const isMenuOpen = Boolean(anchorEl);
  const navigate = useNavigate();
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("attendancePath")
    localStorage.removeItem("practicePath")
    localStorage.removeItem("notesPath")

    navigate("/")
  }

  const handleOpenQR = async () => {
    setQrLoading(true);
    try {
      const response = await getLearnerQRCode(user?.learner?.learner_code);
      if (response?.data) {
        const blob = new Blob([response.data], { type: "image/png" });
        const file = window.URL.createObjectURL(blob);
        setQrImage(file);
        setOpen(true);
      } else {
        throw new Error("Invalid QR code response");
      }
    } catch (error) {
      setOpen(false);
      toast.error(error?.response?.data?.message || error?.message || "Failed to fetch QR code");
      setQrImage(null);

    } finally {
      setQrLoading(false);
    }
  };





  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"))
    setUser(user)
  }, [])

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      PaperProps={{
        style: {
          backgroundColor: '#202124', // Dark background
          color: 'white', // White text
          width: '340px',
        },
      }}
    >
      <MenuItem >
        <Box sx={{ display: 'flex', flexDirection: "column", alignItems: 'center', gap: 2, width: "100%" }}>
          {/* <img src={user?.image} alt="img" /> */}
          <AccountCircle sx={{ fontSize: 60, color: '#9aa0a6' }} />
          <Box sx={{ display: 'flex', flexDirection: "column", alignItems: 'center', }}>
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>
              Hi, {user?.learner?.name}!
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" style={{ color: '#9aa0a6' }}>
                <strong>Email : </strong> {user?.learner?.email}
              </Typography>
              <Typography variant="body2" style={{ color: '#9aa0a6' }}>
                <strong> Mobile : </strong>{user?.learner?.mobile}
              </Typography>
            </Box>
          </Box>
        </Box>
      </MenuItem>
      <Box sx={{ mt: 2, display: "flex", width: "100%", justifyContent: "space-evenly", flexWrap: "wrap" }}>
        <MenuItem sx={{ display: 'flex', justifyContent: "center", alignItems: 'center' }} onClick={handleOpenQR} >
          <QrCodeIcon sx={{ mr: 1, color: '#9aa0a6' }} />
          <Typography style={{ color: 'white' }}>Show QR</Typography>
        </MenuItem>
        <MenuItem sx={{ display: 'flex', justifyContent: "center", alignItems: 'center' }} onClick={handleLogout}>
          <LogoutIcon sx={{ mr: 1, color: '#9aa0a6' }} />
          <Typography style={{ color: 'white' }}>Sign Out</Typography>
        </MenuItem>
      </Box>

    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1, position: 'sticky', top: 0, zIndex: 10, width: '100%' }}>
      <AppBar position="static">
        <Toolbar style={{ backgroundColor: 'white', color: 'black' }}>
          <IconButton size="large" edge="start" color="inherit" sx={{ mr: 2 }} onClick={handleDrawer}>
            <MenuIcon sx={{ fontSize: "40" }} />
          </IconButton>
          <div>
            <img src={logo} alt="Logo" />
          </div>
          <Typography variant="h6" noWrap component="div" sx={{ display: { xs: 'none', sm: 'block', m: 2, fontWeight: 600, fontSize: 16 } }} >
            EJET.AI - Learner
          </Typography>
          <Typography variant="h6" noWrap component="div" sx={{ display: { xs: 'block', sm: 'none', m: 2, fontWeight: 600, fontSize: 16 } }} >
            EJET.AI - Learner
          </Typography>



          <Box sx={{ flexGrow: 1 }} />
          <Box>
            <IconButton
              size="large"
              edge="end"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle sx={{ fontSize: 35 }} />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMenu}
      <LearnerQRModal open={open} onClose={() => setOpen(false)} qrImage={qrImage} qrLoading={qrLoading} user={user} />
    </Box>
  );
}
